/*
*	Author : Kamal Boudlali SQLI
*/
// Form style select/checkbox/radiobox/inputFile
function setFormStyler(){
(function($) {
	$.fn.customSelect = function(settings) {
		var config = {
			replacedClass: 'replaced',
			customSelectClass: 'custom-select',
			activeClass: 'active',
			wrapperElement: '<div class="custom-select-container" />'
		};
		if (settings) {
			$.extend(config, settings);
		}
		this.each(function() {
			var select = $(this);
			select.addClass(config.replacedClass);
			select.wrap(config.wrapperElement);
			var update = function() {
				val = $('option:selected', this).text();
				span.find('span').text(val);
			};
			select.change(update);
			select.keyup(update);
			var span = $('<span class="' + config.customSelectClass + '" aria-hidden="true"><span>' + $('option:selected', this).text() + '</span></span>');
			select.after(span);
			select.on({
				mouseenter: function() {
					span.addClass(config.activeClass);
				},
				mouseleave: function() {
					span.removeClass(config.activeClass);
				},
				focus: function() {
					span.addClass(config.activeClass);
				},
				blur: function() {
					span.removeClass(config.activeClass);
				}
			});
		});
	};
})(jQuery);


$(function(){
	$('.radiostyle').each(function(){
		$(this).find('input[type=radio]').parent('label').find('input[type=radio]').each(function(){
			$(this).css({
				'opacity': 0,
				'width': '1px',
				'height': '1px',
				'position': 'absolute',	
				'zoom': 1
			});	
			$(this).click(function(){
				if($(this).attr('disabled')!='disabled'){
					$(this).parents('.radiostyle').find('input[type=radio]').parent('label').find('input[type=radio]').each(function(){
						if($(this).is(':checked'))
							$(this).parent().addClass('radioOn').removeClass('radioOff');
						else
							$(this).parent().removeClass('radioOn').addClass('radioOff');
					});
				}
			});
			if($(this).prop('checked'))
				$(this).parent().removeClass('radioOff').addClass('radioOn');
			else
				$(this).parent().removeClass('radioOn').addClass('radioOff');
			if($(this).attr('disabled')=='disabled'){
				$(this).parent().removeClass('radioOff radioOn').addClass('RadioDisabled');
			}			
		});
	});
	
	$('.checkstyle').each(function(){
		$(this).find('input[type=checkbox]').parent('label').find('input[type=checkbox]').each(function(){
			$(this).on('click', function(){
				if($(this).is(':checked'))
					$(this).parent().removeClass('checkOff').addClass('checkOn');
				else
					$(this).parent().removeClass('checkOn').addClass('checkOff');
			});
			if($(this).is(':checked'))
				$(this).parent().removeClass('checkOff').addClass('checkOn');
			else
				$(this).parent().removeClass('checkOn').addClass('checkOff');
		});
	});
	$('.checkstyleComparator').each(function(){
		$(this).find('input[type=checkbox]').parent('label').find('input[type=checkbox]').each(function(){
			$(this).css({
				'opacity': 0,
				'width': '1px',
				'height': '1px',
				'position': 'absolute',	
				'zoom': 1
			});			
			$(this).click(function(){
				if($(this).is(':checked')){
					$(this).parent().removeClass('checkOff').addClass('checkOn');
				}else{
					$(this).parent().removeClass('checkOn').addClass('checkOff');
				}
				
			});
			if($(this).is(':checked')){
				$(this).parent().removeClass('checkOff').addClass('checkOn');
			}else{
				$(this).parent().removeClass('checkOn').addClass('checkOff');
			}
		});
	});
}); 

(function($) {
    $.fn.filestyle = function(options) {
        /* TODO: This should not override CSS. */
        var settings = {
            width : 250
        };    
        if(options) {
            $.extend(settings, options);
        };  
        return this.each(function() {
            var self = this;
            var wrapper = $("<div>")
                            .css({
                                "width": settings.imagewidth + "px",
                                "height": settings.imageheight + "px",
                                "background-position": "right",
                                "display": "inline",
                                "position": "absolute",
                                "overflow": "hidden"
                            }).addClass('InputFile');
            var filename = $('<input class="file" disabled="disabled" value="">')
                             .addClass($(self).attr("class"))
                             .css({
                                 "display": "inline",
                                 "width": settings.width + "px"
                             }).val($(self).attr('title'));							 
            $(self).before(filename);
            $(self).wrap(wrapper);
            $(self).css({
                        "position": "relative",
                        "height": settings.imageheight + "px",
                        "width": settings.width + "px",
                        "display": "inline",
                        "cursor": "pointer",
                        "opacity": "0.0"
                    });
            if ($.browser.mozilla) {
                if (/Win/.test(navigator.platform)) {
                    $(self).css("margin-left", "-142px");                    
                } else {
                    $(self).css("margin-left", "-168px");                    
                };
            } else {
                $(self).css("margin-left", settings.imagewidth - settings.width + "px");                
            };
            $(self).on("change", function() {
                filename.val($(self).val());
            });
        });
    };
})(jQuery);
}

setFormStyler();
	
$(document).ajaxComplete(function() {
	setFormStyler();
});
